//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
//Material-ui

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Part
import PartMyProfileStep from './PartMyProfileStep';
import PartCheckbox from './PartCheckbox';
import PartPageTitle from './PartPageTitle';
//Icon
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

//Dialog
import DialogConfirm from './DialogConfirm';
//JSON
var profileItem = require('../data/profileItem.json');


class Comp extends React.Component {
  constructor(props) {
		super(props);

    profileItem.height= [];
    for (let i = 120; i <= 230; i++) {
      profileItem.height.push(i);
    }

    this.state = {
      region: '',
      region_detail: '',
      birthplace: '',
      birthplace_detail: '',
      relationship: '',
      height: 120,
      style: '',
      association: '',
      marriage: '',
      child: '',
      lifestyle: '',
      smorking: '',
      drinking: '',
      gambling: '',
      pet: '',
      house: '',
      car: '',
      academic: '',
      religion: '',
      job: '',
      holiday: [],
      income: '',
      blood: '',
      constellation: '',
      datetime: null,
      init: [],
      editItem: [],
      saveDialog: false,
    }
	}

  componentDidMount() {
    document.title = 'プロフィール(自身について) - パートナーズ';
    this._myProfileGet();
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }


  _myProfileGet() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('item', ['profile']);
    return axios.post(config.apiUri + "member/myProfileApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      this._api2state(res.data.profile);
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


  _api2state(profile) {
    if (profile.userdata_prof_region) {
      this.setState({
        region: profile.userdata_prof_region,
        regionInit: profile.userdata_prof_region,
        region_detail: profile.userdata_prof_region_detail,
        birthplace: profile.userdata_prof_birthplace,
        birthplace_detail: profile.userdata_prof_birthplace_detail,
        relationship: profile.userdata_prof_relationship,
        height: profile.userdata_prof_height,
        style: profile.userdata_prof_style,
        association: profile.userdata_prof_association,
        marriage: profile.userdata_prof_marriage,
        child: profile.userdata_prof_child,
        lifestyle: profile.userdata_prof_lifestyle,
        smorking: profile.userdata_prof_smorking,
        drinking: profile.userdata_prof_drinking,
        gambling: profile.userdata_prof_gambling,
        pet: profile.userdata_prof_pet,
        house: profile.userdata_prof_house,
        car: profile.userdata_prof_car,
        academic: profile.userdata_prof_academic,
        religion: profile.userdata_prof_religion,
        job: profile.userdata_prof_job,
        holiday: profile.userdata_prof_holiday.split(','),
        income: profile.userdata_prof_income,
        blood: profile.userdata_prof_blood,
        constellation: profile.userdata_prof_constellation,
        init: profile,
        datetime: new Date(),
      })
    }
    else {
      this.setState({
        region: '東京都',
        region_detail: '23区',
        birthplace: '',
        birthplace_detail: '',
        relationship: '',
        height: 170,
        style: '普通',
        association: '恋愛',
        marriage: '未婚',
        child: 'いません',
        lifestyle: '一人暮らし',
        smorking: '全くない',
        drinking: '全くない',
        gambling: '全くない',
        pet: 'いません',
        house: '',
        car: '',
        academic: '四年制大学卒業／学士号',
        religion: '',
        job: '事務職',
        holiday: [],
        income: '400万以上 600万未満',
        blood: '',
        constellation: '',
        datetime: new Date(),
      })
    }

  }

  _holidayChange(value) {
		if (this.state.holiday.includes(value)) {
			this.setState({ holiday: this.state.holiday.filter((arr) => { return arr !== value }) });
		}
    else {
      let nextState = [];
      profileItem.holiday.forEach( (item) => {
        if ([...this.state.holiday, value].includes(item.ja)) {
    			nextState.push(item.ja);
    		}
      })
      this.setState({ holiday: nextState });
		}
  }

  _save() {
    let editItem = [];
    if (this.props.my.setting.profileCheck === 1) {
      if(this.state.init.userdata_prof_region !== this.state.region) {
        editItem.push('地域');
      }
      if(this.state.init.userdata_prof_height !== this.state.height) {
        editItem.push('身長');
      }
      if(this.state.init.userdata_prof_style !== this.state.style) {
        editItem.push('体型');
      }
      if(this.state.init.userdata_prof_marriage !== this.state.marriage) {
        editItem.push('結婚歴');
      }
      if(this.state.init.userdata_prof_child !== this.state.child) {
        editItem.push('子供');
      }
      if(this.state.init.userdata_prof_drinking !== this.state.drinking) {
        editItem.push('お酒');
      }
      if(this.state.init.userdata_prof_gambling !== this.state.gambling) {
        editItem.push('ギャンブル');
      }
      if(this.state.init.userdata_prof_smorking !== this.state.smorking) {
        editItem.push('タバコ');
      }
      if(this.state.init.userdata_prof_academic !== this.state.academic) {
        editItem.push('学歴');
      }
      if(this.state.init.userdata_prof_job !== this.state.job) {
        editItem.push('仕事');
      }
      if(this.state.init.userdata_prof_income !== this.state.income) {
        editItem.push('年収');
      }
    }

    if (editItem.length > 0) {
      this.setState({editItem: editItem, saveDialog: true});
    }
    else {
      this._saveSubmit();
    }
  }

  _saveSubmit() {
    this.props.myProfileUserSave(this.state, (data) => {
      if (this.props.location.pathname.match(/^\/new\//)) {
        this.props.history.push('/new/partner/');
      }
      else {
        this.props.history.push('/my/#myProfileUserBox');
      }
    })
  }

  render() {

    let regionDetailItemFilter = profileItem.region_detail.filter( (value, index) => {
      return value.region === this.state.region
    })

    let birthplaceDetailItemFilter = profileItem.region_detail.filter( (value, index) => {
      return value.region === this.state.birthplace
    })

    let relationshipItemFilter = profileItem.relationship.filter( (value, index) => {
      return value.group === this.props.my.profile.userdata_sex
    })

    let saveVisible;
    if (
      (this.state.region) &&
      (this.state.height) &&
      (this.state.style) &&
      (this.state.association) &&
      (this.state.marriage) &&
      (this.state.child) &&
      (this.state.lifestyle) &&
      (this.state.smorking) &&
      (this.state.drinking) &&
      (this.state.gambling) &&
      (this.state.pet) &&
      (this.state.academic) &&
      (this.state.job) &&
      (this.state.income)
    ) {
      saveVisible = true;
    }
    else {
      saveVisible = false;
    }


    return (
      <div>
        {
          (this.props.location.pathname.match(/^\/new\//)) ? (
            <div>
              <PartMyProfileStep step={0} />
              <h1 align='center'>ご自身ついて</h1>
            </div>
          ) : (
            <PartPageTitle
              title={'ご自身ついて'}
              onback={ '/my/' }
            />
          )
        }

        <div align='center' style={{color:'#666',fontSize:'0.9em'}}>
          ご自身について選択してください
        </div>

        <div style={{maxWidth:'600px',margin:'auto'}}>
  		    <table className='profileEditTable'>
            <tbody>
              <tr>
                <td className='left'>地域</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.region}
                      onChange={
                        (event) => {
                          this.setState({region: event.target.value});
                          let index = profileItem.region.findIndex((value) => value.ja === event.target.value);

                      		if (profileItem.region[index].pc) {
                            this.setState({region_detail: profileItem.region[index].pc});
                          }
                          else {
                            this.setState({region_detail: ''});
                          }
                        }
                      }
                    >
                    {
                      profileItem.region.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} detail={value.pc} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                  &nbsp;
                  <FormControl variant="outlined" style={{display: regionDetailItemFilter.length === 0 && 'none' }}>
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.region_detail}
                      onChange={ (event) => this.setState({region_detail: event.target.value}) }
                    >
                      {
                        regionDetailItemFilter.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>出身地</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.birthplace}
                      onChange={
                        (event) => {
                          if (this.state.birthplace !== event.target.value) {
                            this.setState({birthplace_detail: ''});
                          }
                          this.setState({birthplace: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                        profileItem.region.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                  &nbsp;
                  {
                    (this.state.birthplace) && (
                      <FormControl variant="outlined"  style={{display: birthplaceDetailItemFilter.length === 0 && 'none' }}>
                        <Select
                          style={{fontSize:'1.2em'}}
                          value={this.state.birthplace_detail}
                          onChange={ (event) => this.setState({birthplace_detail: event.target.value}) }
                          displayEmpty
                        >
                          <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                          {
                          birthplaceDetailItemFilter.map((value, index) => {
                            return (
                              <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                            )
                          })
                          }
                        </Select>
                      </FormControl>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='left'>続柄</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.relationship}
                      onChange={
                        (event) => {
                          this.setState({relationship: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                      relationshipItemFilter.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>身長</td>
                <td className='right'>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      textAlign:'center',
                      alignItems:'center',
                      justifyContent: 'center'
                    }}
                  >
                    <IconButton onClick={ () => this.setState({height: (this.state.height - 1)}) } style={{marginRight:'10px'}}>
                      <RemoveIcon />
                    </IconButton>
                    <div>
                      <FormControl variant="outlined">
                        <Select
                          style={{fontSize:'1.2em'}}
                          value={this.state.height}
                          onChange={
                            (event) => {
                              this.setState({height: event.target.value});
                            }
                          }
                        >
                        {
                          profileItem.height.map((value, index) => {
                            return (
                              <MenuItem value={value} key={index} style={{fontSize:'1.2em'}}>{value}</MenuItem>
                            )
                          })
                        }
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      &nbsp;cm
                    </div>
                    <IconButton onClick={ () => this.setState({height: (this.state.height + 1)}) }  style={{marginLeft:'10px'}}>
                      <AddIcon />
                    </IconButton>
                  </div>


                </td>
              </tr>
              <tr>
                <td className='left'>体型</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.style}
                      onChange={
                        (event) => {
                          this.setState({style: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.style.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>


                </td>
              </tr>
              <tr>
                <td className='left'>交際希望</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.association}
                      onChange={
                        (event) => {
                          this.setState({association: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.association.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>


                </td>
              </tr>

              <tr>
                <td className='left'>結婚歴</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.marriage}
                      onChange={
                        (event) => {
                          this.setState({marriage: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.marriage.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>子供</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.child}
                      onChange={
                        (event) => {
                          this.setState({child: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.child.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>生活</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.lifestyle}
                      onChange={
                        (event) => {
                          this.setState({lifestyle: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.lifestyle.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>タバコ</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.smorking}
                      onChange={
                        (event) => {
                          this.setState({smorking: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.smorking.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>お酒</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.drinking}
                      onChange={
                        (event) => {
                          this.setState({drinking: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.drinking.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>ギャンブル</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.gambling}
                      onChange={
                        (event) => {
                          this.setState({gambling: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.gambling.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>ペット</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.pet}
                      onChange={
                        (event) => {
                          this.setState({pet: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.pet.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>住まい</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.house}
                      onChange={
                        (event) => {
                          this.setState({house: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                    <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                    {
                      profileItem.house.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>車</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.car}
                      onChange={
                        (event) => {
                          this.setState({car: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                        profileItem.car.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>学歴</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.academic}
                      onChange={
                        (event) => {
                          this.setState({academic: event.target.value});
                        }
                      }
                    >
                    {
                      profileItem.academic.map((value, index) => {
                        return (
                          <MenuItem value={value.ja} key={index} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>宗教</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.religion}
                      onChange={
                        (event) => {
                          this.setState({religion: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                        profileItem.religion.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>仕事</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.job}
                      onChange={
                        (event) => {
                          this.setState({job: event.target.value});
                        }
                      }
                    >
                      {
                        profileItem.job.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>休日</td>
                <td className='right'>
                {
                  profileItem.holiday.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.holiday.includes(value.ja)}
                      click={ (value) => this._holidayChange(value) }
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
                </td>
              </tr>
              <tr>
                <td className='left'>年収</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.income}
                      onChange={
                        (event) => {
                          this.setState({income: event.target.value});
                        }
                      }
                      disabled={ (this.props.my.proof.income === 1) ? true: false }
                    >
                      {
                        profileItem.income.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}} disabled={ (index >= 5) ? true: false}>{value.ja}</MenuItem>
                          )
                        })
                      }

                    </Select>
                  </FormControl>

                  {
                    (this.props.my.proof.income === 1) && (
                      <div style={{ margin:'10px'}}>
                        <div style={{color:'red'}}>収入証明が提出済の為、変更できません。</div>
                        <div style={{color:'red'}}>収入証明を削除してから、変更を行なってください。</div>
                        <Link to='/my/proof/'><u>収入証明の削除はこちら</u></Link>
                      </div>
                    )
                  }

                  <div style={{color:'#666', margin:'10px'}}>
                    <div>
                      1000万以上の設定は収入証明書が必要です。<br />
                      収入証明を申請いただいた際にサポートで変更いたします。
                    </div>
                    <div >
                      {
                        (this.props.my.setting.profileCheck === 1) && (
                          <Button
                            variant="outlined"
                            color='primary'
                            onClick={ () => this.props.history.push('/my/proof/income') }
                          >
                            収入証明を申請する
                          </Button>
                        )
                      }
                    </div>
                  </div>


                </td>
              </tr>
              <tr>
                <td className='left'>血液型</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.blood}
                      onChange={
                        (event) => {
                          this.setState({blood: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                        profileItem.blood.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className='left'>星座</td>
                <td className='right'>
                  <FormControl variant="outlined">
                    <Select
                      style={{fontSize:'1.2em'}}
                      value={this.state.constellation}
                      onChange={
                        (event) => {
                          this.setState({constellation: event.target.value});
                        }
                      }
                      displayEmpty
                    >
                      <MenuItem value='' key={0}><span style={{color:'#999',fontSize:'1.2em'}}>未設定</span></MenuItem>
                      {
                        profileItem.constellation.map((value, index) => {
                          return (
                            <MenuItem value={value.ja} key={index + 1} style={{fontSize:'1.2em'}}>{value.ja}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{height:'80px',width:'100%'}}></div>

        {
          (saveVisible) && (
            <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
              <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
                <div style={{padding:'10px'}}>
                  <Button
                    variant="contained"
                    color='primary'
                    onClick={ () => this._save() }
                    style={{width: '100%'}}
                  >
                    <div>
                      <div style={{fontSize:'1.2em'}}>プロフィールを登録する</div>

                    </div>
                  </Button>
                </div>
              </div>
            </div>
          )
        }

        <DialogConfirm
          open={ this.state.saveDialog }
          title={'プロフィールを変更しますか?'}
          content={(
            <div>
              <div>
                { this.state.editItem.join(",") }の変更はサポートに変更内容が送信されます。
              </div>
              <div>
                繰り返し変更された場合、プロフィールに変更履歴が表示されます。
              </div>
            </div>
          )}
          apply={ () => this._saveSubmit() }
          close={ () => this.setState({saveDialog: false}) }
        />
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
